// store/slices/maintenanceSlice.js
import { createSlice } from "@reduxjs/toolkit";

const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState: {
    // `active` drives the full-screen maintenance overlay. It is turned on
    // automatically by the axios response interceptor when the API returns a
    // 503 carrying the maintenance marker, and turned off again on the next
    // healthy response.
    active: false,
    message: "",
  },
  reducers: {
    setMaintenance: (state, action) => {
      state.active = true;
      const message = action.payload;
      if (typeof message === "string" && message.trim().length > 0) {
        state.message = message;
      }
    },
    clearMaintenance: (state) => {
      state.active = false;
      state.message = "";
    },
  },
});

export const { setMaintenance, clearMaintenance } = maintenanceSlice.actions;
export default maintenanceSlice.reducer;
